/* NodePalette — Left sidebar with draggable node types */
import { useMemo } from 'react';
import css from '../AutomationEditor.module.css';
import type { AutomationNodeDef } from '../../../types/automations';

interface Props {
  nodeDefs: AutomationNodeDef[];
}

export default function NodePalette({ nodeDefs }: Props) {
  const grouped = useMemo(() => {
    const groups: Record<string, AutomationNodeDef[]> = {
      trigger: [],
      condition: [],
      action: [],
      control: [],
      end: [],
    };
    for (const nd of nodeDefs) {
      if (groups[nd.category]) groups[nd.category].push(nd);
    }
    return groups;
  }, [nodeDefs]);

  const categoryLabels: Record<string, string> = {
    trigger: 'Triggers',
    condition: 'Conditions',
    action: 'Actions',
    control: 'Controls',
    end: 'End',
  };

  function onDragStart(event: React.DragEvent, defKey: string) {
    event.dataTransfer.setData('application/automation-node-def', defKey);
    event.dataTransfer.effectAllowed = 'move';
  }

  return (
    <div className={css.palette}>
      <div className={css.paletteHeader}>Node Palette</div>

      {Object.entries(grouped).map(([category, defs]) =>
        defs.length > 0 ? (
          <div key={category}>
            <div className={css.paletteCategory}>{categoryLabels[category] || category}</div>
            {defs.map((nd) => (
              <div
                key={nd.key}
                className={css.paletteItem}
                draggable
                onDragStart={(e) => onDragStart(e, nd.key)}
                title={nd.description || nd.name}
              >
                <div
                  className={css.paletteItemDot}
                  style={{ backgroundColor: nd.color || '#888' }}
                />
                {nd.name}
              </div>
            ))}
          </div>
        ) : null,
      )}
    </div>
  );
}
